import { apiClient } from "../lib/axios";
import { handleApiError } from "../lib/error-handling";

export interface PricingPlan {
  id: string;
  name: string;
  price: number;
  features: string[];
  popular?: boolean;
  highlightColor?: string;
}

export interface PlanData {
  plans: PricingPlan[];
}

export interface GetPricingPlansResponse {
  message: string;
  data: PlanData;
}

export async function getPricingPlans(): Promise<GetPricingPlansResponse> {
  try {
    const response = await apiClient.get<GetPricingPlansResponse>("/api/plans");
    return response.data;
  } catch (error: unknown) {
    throw new Error(handleApiError(error));
  }
}

export interface ContactFormData {
  name: string;
  email: string;
  message: string;
}

export interface ContactFormSubmissionResponse {
  message: string;
}

export async function submitContactForm(
  formData: ContactFormData
): Promise<ContactFormSubmissionResponse> {
  try {
    const response = await apiClient.post<ContactFormSubmissionResponse>(
      "/api/contact",
      formData
    );
    return response.data;
  } catch (error: unknown) {
    throw new Error(handleApiError(error));
  }
}

// You can add more API functions here for other backend interactions (e.g., login, user data, etc.)
// Example:
// export interface User { id: string; name: string; email: string; }
// export async function getUser(userId: string): Promise<User> {
//   try {
//     const response = await apiClient.get<User>(`/api/users/${userId}`);
//     return response.data;
//   } catch (error: unknown) {
//     throw new Error(handleApiError(error));
//   }
// }
